import { render, staticRenderFns } from "./ComplianceCheck.vue?vue&type=template&id=850ca52c&"
import script from "./ComplianceCheck.vue?vue&type=script&lang=js&"
export * from "./ComplianceCheck.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceCheck.vue?vue&type=style&index=0&id=850ca52c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports